import { ApiPrice } from '@ibe/api';
import PurchaseItem from './PurchaseItem';

class AddExtrasEvent {
  extrasPrice: ApiPrice;

  purchasedExtras: PurchaseItem[] | null;

  bookingNumber: string;
}

export default AddExtrasEvent;
